import { datadogRum } from '@datadog/browser-rum';
import { useMutation } from '@tanstack/react-query';

import { patchAutoAssignMutation } from '@cfa/pathway-fe-shared/xp';

import {
  invalidateAllPlanQueries,
  invalidateCertificateQueries,
} from '@/utils/queryInvalidation';

export const usePatchAutoAssign = () =>
  useMutation({
    ...patchAutoAssignMutation(),
    onSuccess: async (_data, variables) => {
      await Promise.all([
        invalidateAllPlanQueries(variables.path.planId),
        invalidateCertificateQueries(variables.path.planId),
      ]);
    },
    onError: error => {
      datadogRum.addError(error, { section: 'autoAssign' });
    },
  });
